export const PricingPlanTypes =  {
    noPlan: 0,
    azPlan: 1,
    xPlanPartners: 2,
    xPlanFriends: 3
};

export default PricingPlanTypes;
